module.exports = __webpack_public_path__ + "components/modal-app-popup/static/unknown-icon-b9b3b40f33cec4cf6bdbf2bdd4db8fc4.webp";